///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'div[windeGridEmpty]',
    standalone: false
})
export class GirdEmptyBlockDirective {
    @HostBinding('class') buttonClass = 'winde-grid-empty-block';
}
